import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaRegImage, FaRegNewspaper, FaTimes } from 'react-icons/fa';

import pressImg1 from '../assets/WhatsApp Image 2026-05-04 at 09.13.07 (1).jpeg';
import pressImg2 from '../assets/WhatsApp Image 2026-05-04 at 09.13.07.jpeg';
import pressImg3 from '../assets/WhatsApp Image 2026-05-04 at 09.13.08 (1).jpeg';
import pressImg4 from '../assets/WhatsApp Image 2026-05-04 at 09.13.08.jpeg';
import pressImg5 from '../assets/WhatsApp Image 2026-05-04 at 09.13.09.jpeg';
import pressImg6 from '../assets/WhatsApp Image 2026-05-05 at 21.23.59.jpeg';
import pressImg7 from '../assets/2nd july news janprawas.jpeg';
import pressImg8 from '../assets/2 july news keasari.jpeg';

import galleryImg1 from '../assets/Screenshot 2026-06-11 183033.png';
import galleryImg2 from '../assets/WhatsApp Image 2026-06-11 at 7.14.28 PM.jpeg';

const Media = () => {
    const { t, i18n } = useTranslation();
    const [activeTab, setActiveTab] = useState('photos');
    const [selectedPhoto, setSelectedPhoto] = useState(null);

    const photos = [
        {
            id: 1,
            title: i18n.language === 'en'
                ? 'Cooperation and experience sharing! Choundeshwari Patsanstha Founder Shri Suryakant Kaka Buchade, Chairman Shri Chandradeep Bhaiya Buchade, Vice Chairman Vishal Mhetre and other directors visited Samata Patsanstha in Ahilyanagar, Kopargaon.'
                : 'एकजुटीने घडलेली, विश्वासाने वाढलेली समता ! श्री चौंडेश्वरी पतसंस्थेचे संस्थापक मा. सूर्यकांत काका बुचडे, मा. चेअरमन चंद्रदीप भैय्या बुचडे, व्हाईस चेअरमन विशाल म्हेत्रे व इतर पदाधिकाऱ्यांनी सहकार्य व अनुभवांची देवाणघेवाण करण्याच्या हेतूने अहिल्यानगर, कोपरगाव येथील समता पतसंस्थेस भेट दिली.',
            date: '11 Jun 2026',
            category: 'Events',
            image: galleryImg1
        },
        {
            id: 2,
            title: i18n.language === 'en'
                ? '33 years of trust, stability and progress! On 25th April, the grand inauguration ceremony of Shri Choundeshwari Patsanstha\'s "Palus Town Branch" was held with great enthusiasm.'
                : 'विश्वासाची 33 वर्षांची परंपरा, स्थिरता आणि प्रगतीचा भक्कम प्रवास! २५ एप्रिलला आपल्या श्री चौंडेश्वरी पतसंस्थेच्या \'पलूस शहर शाखेचा\' शुभारंभ सोहळा मोठ्या उत्साहात संपन्न झाला.',
            date: '11 Jun 2026',
            category: 'Events',
            image: galleryImg2
        }
    ];

    const press = [
        {
            id: 1,
            title: i18n.language === 'en'
                ? "Choundeshwari Credit Society's Vita Branch Celebrates Its First Anniversary with Enthusiasm. Achieves ₹4 Crore in Deposits; Disburses ₹2 Crore in Loans, Marking Strong Growth."
                : "विट्यातील श्री चौंडेश्वरी पतसंस्थेच्या शाखेचा प्रथम वर्धापनदिन उत्साहात साजरा. ४ कोटी ठेवींचा टप्पा पूर्ण; २ कोटी रुपयांचे कर्जवाटप करत शाखेची दमदार भरारी.",
            source: i18n.language === 'en' ? 'Janpravas' : 'जनप्रवास',
            date: '02 Jul 2026',
            excerpt: '',
            image: pressImg7
        },
        {
            id: 2,
            title: i18n.language === 'en'
                ? "Choundeshwari Credit Society's Vita Branch Celebrates Its Anniversary with Enthusiasm, Deposits Reach the ₹4 Crore Milestone."
                : "विट्यातील श्री चौंडेश्वरी पतसंस्थेच्या शाखेचा वर्धापनदिन उत्साहात साजरा, ठेवींनी गाठला ४ कोटी रुपयांचा टप्पा.",
            source: i18n.language === 'en' ? 'Kesari' : 'केसरी',
            date: '02 Jul 2026',
            excerpt: '',
            image: pressImg8
        },
        {
            id: 3,
            title: i18n.language === 'en' ? "Inauguration of Shri Choundeshwari Patsanstha's Palus Town Branch" : 'श्री चौंडेश्वरी पतसंस्थेच्या पलूस शहर शाखेचा प्रारंभ',
            source: i18n.language === 'en' ? 'Punya Nagari' : 'पुण्य नगरी',
            date: '04 May 2026',
            excerpt: '',
            image: pressImg1
        },
        {
            id: 4,
            title: i18n.language === 'en' ? 'Inauguration of Shri Choundeshwari Patsanstha Branch in Palus' : 'पलूस येथे श्री चौंडेश्वरी पतसंस्थेच्या शाखेचा प्रारंभ',
            source: i18n.language === 'en' ? 'Janpravas' : 'जनप्रवास',
            date: '04 May 2026',
            excerpt: '',
            image: pressImg2
        },
        {
            id: 5,
            title: i18n.language === 'en' ? 'Grand Opening of Shri Choundeshwari Patsanstha Town Branch & Website Launch Ceremony' : 'श्री चौंडेश्वरी पतसंस्थेच्या  शहर  शाखेचा शुभारंभ. वेबसाईट अनावरण सोहळा उत्साहात : मान्यवरांची उपस्थिती.',
            source: i18n.language === 'en' ? 'Tarun Bharat' : 'तरुण भारत',
            date: '04 May 2026',
            excerpt: '',
            image: pressImg3
        },
        {
            id: 6,
            title: i18n.language === 'en' ? 'Cooperative institutions will survive only if loan distribution is done after assessing security and reasons' : 'तारण, कारण पाहून कर्ज वाटप केले तरच पतसंस्थांचे अस्तित्व राहील.',
            source: i18n.language === 'en' ? 'Kesari' : 'केसरी',
            date: '04 May 2026',
            excerpt: '',
            image: pressImg4
        },
        {
            id: 7,
            title: i18n.language === 'en' ? 'Inauguration of Shri Choundeshwari Patsanstha Palus Branch & Website Launch' : 'श्री चौंडेश्वरी पतसंस्थेच्या पलूस  शाखेचा प्रारंभ, वेबसाईटचे  अनावरण',
            source: i18n.language === 'en' ? 'Pudhari' : 'पुढारी',
            date: '04 May 2026',
            excerpt: '',
            image: pressImg5
        },
        {
            id: 8,
            title: i18n.language === 'en' ? "Inauguration of Choundeshwari's Town Branch" : '\'चौंडेश्वरी\' च्या शहर शाखेचा शुभारंभ',
            source: i18n.language === 'en' ? 'Lokmat' : 'लोकमत',
            date: '05 May 2026',
            excerpt: '',
            image: pressImg6
        }
    ];



    return (
        <div className="min-h-screen bg-gray-50 text-gray-800 font-sans">
            {/* 1. Hero Section */}
            <section className="relative py-24 bg-gradient-to-r from-slate-900 to-slate-800 text-white overflow-hidden">
                <div className="absolute inset-0 opacity-20 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:20px_20px]"></div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
                    <span className="text-secondary font-bold tracking-widest uppercase text-sm mb-4 block">
                        {t('mediaPage.badge')}
                    </span>
                    <h1 className="text-4xl md:text-5xl font-bold mb-6 font-display">
                        {t('mediaPage.title')}
                    </h1>
                    <div className="w-24 h-1 bg-secondary mx-auto mb-6"></div>
                    <p className="text-xl text-blue-100 max-w-2xl mx-auto leading-relaxed">
                        {t('mediaPage.subtitle')}
                    </p>
                </div>
            </section>

            {/* 2. Tab Navigation */}
            <section className="relative z-20 -mt-8 max-w-4xl mx-auto px-4">
                <div className="bg-white rounded-xl shadow-lg p-2 border border-gray-100 flex justify-between gap-2">
                    <button
                        onClick={() => setActiveTab('photos')}
                        className={`flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-lg font-semibold transition-all duration-300 text-sm md:text-base ${activeTab === 'photos' ? 'bg-primary text-white shadow-md' : 'text-gray-600 hover:bg-gray-100'}`}
                    >
                        <FaRegImage />
                        {t('mediaPage.photosTab')}
                    </button>
                    <button
                        onClick={() => setActiveTab('press')}
                        className={`flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-lg font-semibold transition-all duration-300 text-sm md:text-base ${activeTab === 'press' ? 'bg-primary text-white shadow-md' : 'text-gray-600 hover:bg-gray-100'}`}
                    >
                        <FaRegNewspaper />
                        {t('mediaPage.newsTab')}
                    </button>
                </div>
            </section>

            {/* 3. Media Content Section */}
            <section className="py-20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    {/* Photos Tab */}
                    {activeTab === 'photos' && (
                        <div>
                            <div className="text-center mb-12">
                                <h2 className="text-3xl font-bold text-gray-900 mb-2">{t('mediaPage.galleryTitle')}</h2>
                                <p className="text-gray-600 max-w-xl mx-auto">{t('mediaPage.gallerySubtitle')}</p>
                                <div className="w-12 h-1 bg-secondary mx-auto mt-4"></div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
                                {photos.map((photo) => (
                                    <div
                                        key={photo.id}
                                        onClick={() => setSelectedPhoto(photo)}
                                        className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl border border-gray-100 transition-all duration-300 flex flex-col group cursor-pointer"
                                    >
                                        <div className="relative overflow-hidden aspect-video">
                                            <img
                                                src={photo.image}
                                                alt={photo.title}
                                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                            />
                                            <div className="absolute inset-0 bg-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                                                <div className="bg-white/90 text-primary px-3 py-1.5 rounded-full text-xs font-bold shadow-md">
                                                    View Photo
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-5 flex-grow flex flex-col justify-between">
                                            <h3 className="font-medium text-slate-600 text-sm md:text-base group-hover:text-primary transition-all duration-300 whitespace-pre-line leading-relaxed">
                                                {photo.title}
                                            </h3>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Press Coverage Tab */}
                    {activeTab === 'press' && (
                        <div>
                            <div className="text-center mb-12">
                                <h2 className="text-3xl font-bold text-gray-900 mb-2">{t('mediaPage.pressTitle')}</h2>
                                <p className="text-gray-600 max-w-xl mx-auto">{t('mediaPage.pressSubtitle')}</p>
                                <div className="w-12 h-1 bg-secondary mx-auto mt-4"></div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
                                {press.map((item) => (
                                    <div
                                        key={item.id}
                                        onClick={() => setSelectedPhoto(item)}
                                        className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl border border-gray-100 transition-all duration-300 flex flex-col group cursor-pointer"
                                    >
                                        <div className="relative overflow-hidden aspect-video flex-shrink-0">
                                            <img
                                                src={item.image}
                                                alt={item.title}
                                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                            />
                                            <div className="absolute inset-0 bg-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                                                <div className="bg-white/90 text-primary px-3 py-1.5 rounded-full text-xs font-bold shadow-md">
                                                    View Press Cut
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-6 flex-grow flex flex-col justify-between">
                                            <div>
                                                <div className="flex items-center justify-between text-xs text-primary font-semibold tracking-wider mb-2">
                                                    <span>{item.source}</span>
                                                </div>
                                                <h3 className="font-bold text-gray-900 text-sm md:text-base mb-1 group-hover:text-primary transition-all duration-300 leading-relaxed whitespace-pre-line">
                                                    {item.title}
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </section>

            {/* Photo Modal Overlay */}
            {selectedPhoto && (
                <div
                    className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4 backdrop-blur-sm transition-all duration-300 animate-fadeIn"
                    onClick={() => setSelectedPhoto(null)}
                >
                    <div className="relative max-w-4xl w-full max-h-[90vh] flex flex-col items-center">
                        <button
                            onClick={() => setSelectedPhoto(null)}
                            className="absolute -top-12 right-0 text-white hover:text-secondary text-2xl transition-colors bg-white/10 p-2 rounded-full"
                        >
                            <FaTimes />
                        </button>
                        <img
                            src={selectedPhoto.image}
                            alt={selectedPhoto.title}
                            className="max-h-[75vh] w-auto max-w-full object-contain rounded-lg shadow-2xl"
                            onClick={(e) => e.stopPropagation()}
                        />
                        <div
                            className="mt-4 text-center text-white px-6 py-3 bg-white/5 backdrop-blur-md rounded-xl border border-white/10 max-w-2xl"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <h4 className="font-bold text-lg whitespace-pre-line">{selectedPhoto.title}</h4>
                            {selectedPhoto.source && (
                                <p className="text-xs text-secondary mt-1">{selectedPhoto.source}</p>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Media;
